require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-04-20-thursday.json") })
        }
      }, "path---articles-2007-04-20-thursday");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-04-20-thursday!./.cache/json/articles-2007-04-20-thursday.json
// module id = 508
// module chunks = 231608221292675